import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { axios } from '@/library/axios';
import type { StatesResponse } from '@/types/auth';
import type { State } from '@/utils/functions';

const getStates = async (): Promise<StatesResponse> => {
  const response = await axios.get('/states');
  return response.data;
};

// type QueryFnType = typeof getStates;

// type UseGetStateOptions = {
//   config?: QueryConfig<QueryFnType>;
// };
export const useGetStates = () => {
  const [states, setStates] = useState<State[]>([]);
  // TOFIX pass useErrorBoundary false from component in params - Teja
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: ['states'],
    queryFn: () => getStates(),
    useErrorBoundary: false, // ...config
  });

  const resultList = data?.data;

  const uniqueStates: State[] = [];
  resultList?.reduce((prevState: State, currentState: State): any => {
    if (prevState && prevState.stateName === currentState.stateName) return {};
    uniqueStates.push(currentState);
    return currentState;
  }, {} as State);

  useEffect(() => {
    if (!isLoading && data) {
      // const formattedStates = formatStates(data?.data);
      setStates(uniqueStates);
    }
  }, [data, isLoading]);

  return {
    states,
    isLoading,
    isSuccess,
  };
};
